import script from "./NotarialActionRedactor.vue?vue&type=script&setup=true&lang=js"
export * from "./NotarialActionRedactor.vue?vue&type=script&setup=true&lang=js"

import "./NotarialActionRedactor.vue?vue&type=style&index=0&id=8d5e9724&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d5e9724"]])

export default __exports__